import { adaptCategories } from './utils';

export const dropdownConfig = [
  {
    name: 'isInReport:switch',
    displayName: 'Should question be visible in Report?',
    default: false,
    category: 'Reports',
  },
  {
    name: 'mainChart',
    displayName: 'Choose Main chart',
    choices: [
      'none',
      'bar-stacked',
      'open-question',
      'bar',
      'bar-nps',
      'statements-bar-raw',
    ],
    default: 'none',
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    dependsOn: ['isInReport'],
  },
  {
    name: 'dontKnowText',
    displayName: 'Dont know text',
    default: false,
    category: 'Dont know',
  },
  {
    name: 'dontKnowValue',
    displayName: 'Dont know value',
    category: 'Dont know',
  },
  {
    name: 'customZeroAnswersLabel:shortText',
    default: '',
    displayName: 'Type custom 0% answers label',
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'statements-bar';
    },
    isLocalizable: true,
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'secondaryChart',
    default: 'none',
    displayName: 'Choose Secondary chart',
    choices: ['none', 'open-question', 'bar', 'bar-nps'],
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart !== 'none';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'isCollapsable:switch',
    displayName: 'is Collapsable display?',
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.secondaryChart !== 'none';
    },
    dependsOn: ['isInReport', 'secondaryChart'],
  },
  {
    name: 'mainCategory',
    default: 'none',
    displayName: 'Choose Main category',
    choices: function (obj: any) {
      const { reportCategories } = obj.survey;

      if (reportCategories) {
        return ['none', ...adaptCategories(reportCategories.categories)] || [];
      }

      return [];
    },
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    dependsOn: ['isInReport'],
  },
  {
    name: 'secondaryCategory',
    default: 'none',
    displayName: 'Choose Secondary category',
    choices: function (obj: any) {
      const { reportCategories } = obj.survey;

      if (reportCategories) {
        return (
          ['none', ...adaptCategories(reportCategories.subcategories)] || []
        );
      }

      return [];
    },
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    dependsOn: ['isInReport'],
  },
];
